<template>
  <div>
    <sectionHeading text="New Arrivals" />

    <div class="productContainer">
      <productCard
        v-for="product in productData"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import productCard from "@/components/common/ProductCard.vue";
import productsData from "@/assets/data/productsList.js";

export default {
  name: "secondSection",
  data() {
    return {
      productData: new Array()
    };
  },
  created() {
    this.productData.push(productsData[1]);
    this.productData.push(productsData[5]);
    this.productData.push(productsData[9]);
  },
  components: {
    productCard
  }
};
</script>

<style lang="scss" scoped>
.productContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  justify-content: center;
  @include media-md {
    justify-content: space-around;
  }

  .productCard {
    width: 80%;
    max-width: 400px;
    @include media-md {
      min-width: 30%;
      width: 30%;
    }
    margin: 0;
  }
}
</style>
